import { LightbulbOn90Icon } from './LightbulbOn90Icon';

/**
 * author: Michael Irigoyen
 * id 33D9D6A7-250C-46B6-9FD2-81A6477CC8EC
 * name lightbulb-on-90
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-on-90.svg
 * tags
 * - Home Automation 
 */
export const LightbulbDimmer90Icon = LightbulbOn90Icon;
export default LightbulbDimmer90Icon